import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { MaterialModule } from './material/material.module';
import { ImagecardComponent } from './imagecard/imagecard.component';
import { SigninComponent } from './signin/signin.component';
import { MediaComponent } from './media/media.component';
import { VideoplayerComponent } from './videoplayer/videoplayer.component';
import { ImageViewerComponent } from './image-viewer/image-viewer.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ViewImageComponent } from './view-image/view-image.component';
import { ActiveslidePipe } from '../_pipe/activeslide.pipe';
import { ScrollTopComponent } from './scroll-top/scroll-top.component';
import { ImageWithLoadingComponent } from './image-with-loading/image-with-loading.component';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';
import { MatSelectSearchComponent } from './mat-select-search/mat-select-search.component';


@NgModule({
  declarations: [
    FooterComponent,
    HeaderComponent,
    ImagecardComponent,
    SigninComponent,
    MediaComponent,
    VideoplayerComponent,
    ImageViewerComponent,
    ViewImageComponent,
    ActiveslidePipe,
    ScrollTopComponent,
    ImageWithLoadingComponent,
    PdfViewerComponent,
    MatSelectSearchComponent,
  ],
  imports: [
    CommonModule,
     MaterialModule,
      NgbModule,
    ],
  exports: [
    MaterialModule,
    NgbModule,
    FooterComponent,
    HeaderComponent,
    ImagecardComponent,
    SigninComponent,
    MediaComponent,
    VideoplayerComponent,
    ImageViewerComponent,
    ViewImageComponent,
    ActiveslidePipe,
    ScrollTopComponent,
    ImageWithLoadingComponent,
    PdfViewerComponent,
    MatSelectSearchComponent
  ]
})
export class ComponentModule {}
